module.exports = __webpack_public_path__ + "static/oceanarium-c0d632e2e4ee6f4529e1306f515698ac.mp3";